import React from 'react';
import SuggestionsPage from '../../components/hairstyles/SuggestionsPage';

const BarberSuggestions = () => {
  return <SuggestionsPage />;
};

export default BarberSuggestions;
